import gql from 'graphql-tag'

import { UserFragment } from '../fragments'

const mutation = gql`
  mutation ClearAllNotifications {
    clearAllNotifications {
      errors {
        key
        message
      }
      currentUser {
        id
        ...User
      }
    }
  }
  ${UserFragment}
`

export default mutation
